<style>
    .remove-header > .ivu-modal > .ivu-modal-content > .ivu-modal-header {
        display: none !important;
    }
    .verify-template{
        z-index:1010 !important;
    }
</style>

<template>
    <div>
        <ModalHolder className="remove-header verify-template" title="" m-height="auto" :is-show="showVerifyModal">
            <template slot='mcontent'>
            <div>
                <div>
                    <!-- <img alt=" " @click="hideModal()" style="height: 25px; width: 25px; top: 10px; right: 10px;position: absolute;" src="@/assets/close.png">  -->
                    <div style="display:block"><b style="color: #1c2438;display: flex;font-size: 14px;font-weight: 700;">Verification!</b></div>
                </div>
                <div style="display:flex;margin-top:10px">
                    <Icon v-if="isSuccess" style="margin-right:10px" size="36" color="#19be6b" type="checkmark-circled"></Icon>
                    <Icon v-else style="margin-right:10px" size="36" color="#f90" type="help-circled"></Icon>
                    <div style="margin-top:8px">
                        <span v-if="isSuccess"> Successfully sent. </span>
                        <div v-else> 
                            <span>
                                Please verify email / contact.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            </template>
            <template slot='mfooter'>
                <Button v-if="isSuccess" type="primary" @click='hideModal()'>Ok</Button>
                <div v-else>            
                    <Button type="text" @click='hideModal()'>Cancel</Button>
                    <Button type="primary" @click='resendConfirmation()' :loading="isSending">Resend</Button>
                </div>
            </template>
        </ModalHolder>
    </div>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
export default {
    data() {
        return {
            isSuccess: false,
            isSending: false
        }
    },
    methods:{
        resendConfirmation() {
            this.isSending = true;
            this.$store.dispatch('base/resendEmailConfirmation').then(
                res => {
                    this.isSuccess = true;
                    this.isSending = false;
                }, error => {
                    this.isSending = false;
                    this.isSuccess = false;
                }
            );
        },
        hideModal(){
            this.isSuccess = false;
            this.$store.commit('user/showVerifyModal', false)
        }
    },
    computed:{
        userInfoEmail:{
            get(){
                return (this.$store.state.user && this.$store.state.user.info) ? this.$store.state.user.info.email : ''
            }
        },
        showVerifyModal:{
            get(){
                return this.$store.state.user.showVerifyModal
            }
        },
    },
    components:{ModalHolder}
}
</script>

